import src from "IMAGE";
export default { src, width: 534, height: 544, blurWidth: 0, blurHeight: 0};
